import React from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { enUS, frFR, esES } from '@mui/material/locale';
import theme from 'theme';
import 'styles/index.css';

const locales = { en: enUS, fr: frFR, es: esES };
function CustomThemeProvider({ children }) {
  const { i18n } = useTranslation();
  const { data } = useSelector((state) => state.branding);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme({ ...data, locale: locales[i18n.language] })}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
}

CustomThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CustomThemeProvider;
